import * as A from "fp-ts-esm/Array";
import { pipe } from "fp-ts-esm/function";
import { fromPredicate } from "fp-ts-esm/Option";
import * as T from "fp-ts-esm/Tree";
import { Lens, Prism, fromTraversable } from "monocle-ts-esm";
const getExtractor = (nodesAccessor) => (root) => {
  class TraversalExtractor {
    constructor(traversal, tree2) {
      this.traversal = traversal;
      this.tree = tree2;
    }
    // @ts-ignore $TSFixMe
    filter(predicate) {
      return new TraversalExtractor(
        this.traversal.composePrism(Prism.fromPredicate(predicate)),
        this.tree
      );
    }
    // @ts-ignore $TSFixMe
    map(mapper) {
      return new TraversalExtractor(
        this.traversal.composeLens(new Lens(mapper, () => (dt) => dt)),
        this.tree
      );
    }
    // @ts-ignore $TSFixMe
    chain(mapper) {
      return pipe(this.get(), A.map(mapper));
    }
    get() {
      return pipe(
        this.traversal.asFold().getAll(this.tree),
        A.map(fromPredicate(Boolean)),
        A.compact
      );
    }
  }
  const tree = T.unfoldTree(root, (node) => [node, nodesAccessor(node)]);
  return new TraversalExtractor(fromTraversable(T.tree)(), tree);
};
export {
  getExtractor
};
//# sourceMappingURL=extractor-infra.js.map
